// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__3BJP3","warningModal":"Section_warningModal__yjBqC"};